import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { ChatPanel } from "./ChatPanel";

// Foglio modale (mobile / tablet) che ospita la Chat CFO.
// Il core (messaggi + composer) vive in ChatPanel, riusato anche dal rail
// destro desktop in HomeDesktop.
export const ChatSheet = ({ open, onClose }) => {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50" data-testid="chat-sheet">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/70 backdrop-blur-[2px]"
          />
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="absolute inset-x-0 bottom-0 top-12 mx-auto flex max-w-[430px] flex-col overflow-hidden rounded-t-[12px] border border-b-0 border-white/[0.08] bg-[#030305]"
          >
            {/* header terminale */}
            <div className="border-b border-white/[0.06] px-4 pb-3 pt-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="mono text-sm font-medium tracking-[0.1em] text-[#00FF87]">
                    CFO <span className="text-white/25">//</span> LIQO
                  </span>
                  <span className="caps-tag flex items-center gap-1.5 text-[#00FF87]/70">
                    <span className="liqo-dot-pulse h-1 w-1 bg-[#00FF87]" />
                    Online
                  </span>
                </div>
                <button
                  onClick={onClose}
                  data-testid="chat-close-button"
                  aria-label="Chiudi chat"
                  className="flex h-8 w-8 items-center justify-center rounded-[6px] border border-white/[0.08] text-white/55 hover:bg-white/[0.05]"
                >
                  <X size={14} />
                </button>
              </div>
            </div>

            <ChatPanel active={open} />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
